import { useEffect, useRef, useState, useCallback } from "react";
import {
  Typography,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Button,
  Autocomplete,
  Select,
  Box,
  Divider,
  TextField,
  InputBase,
  MenuItem,
} from "@mui/material";

import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

import WithLoginLayout from "../../Layout/withLoginLayout";
import {
  addressQualification,
  unifiedLoginWithMobileNumber,
  AMS_Lookup,
} from "../../../../shared/hooks/useFetchCompleteAddress";
import { useLocation, useNavigate } from "react-router-dom";

import { debounce, phoneNumberValidationMask } from "../../Utils/utils";
import {
  logout,
  startLoading,
  stopLoading,
} from "../../SharedContextStore/slices/user";
import { clearNextPaymentDetailSlice } from "../../SharedContextStore/slices/nextPaymentDetails";
import { clearPaymentHistorySlice } from "../../SharedContextStore/slices/paymentHistory";
import { clearPaymentMethodsSlice } from "../../SharedContextStore/slices/paymentMethods";
import { clearServiceDetailSlice } from "../../SharedContextStore/slices/serviceDetails";
import { clearUpcomingAppointmentSlice } from "../../SharedContextStore/slices/upComingAppointment";
import { clearPastAppointmentSlice } from "../../SharedContextStore/slices/pastAppointment";
import {
  clearPlanDetailSlice,
  setChangePlanUrl,
} from "../../SharedContextStore/slices/planDetails";
import AllUrls from "../../../../shared/utils/ApiUrls";

import { useAppDispatch, useAppSelector } from "../../hooks";
import { getLoginPageContent } from "../../SharedContextStore/slices/contentDetails";
import { onEnterKeyPress } from "../../Utils/utils";
import LoginRegFooter from "./loginRegFooter";
import { allowedNodeEnvironmentFlags } from "process";
import RECAPTCHA from "react-google-recaptcha";
import "./logReg.css";
import ToastCustonIcon from "../../SharedComponents/toastCustomIcons";
import { uniLogineventGTM } from "../../Utils/googleTags";
import { sendEventLog } from "../../Utils/app-log";
import { getAMSToken } from "../../SharedContextStore/slices/amsToken";
import { dwLogging } from "../../../../shared/hooks/useFetchLogin";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import useBrightspeedHeaders from "../../hooks/useBrightspeedHeader";
import { useCustomNavigate } from "../../Utils/navigationUtils";
import { LoginContent } from "../../SharedComponents/contents";
import { clearProductCategoriesSlice } from "../../SharedContextStore/slices/shopExpProducts";
import { clearAccordionStateSlice } from "../../SharedContextStore/slices/shopaccordion";
import { clearinternetProductsSlice } from "../../SharedContextStore/slices/InternetProductsState";
import { resetAllBanners } from "../../SharedContextStore/slices/notifications";


const BootstrapAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      padding: "0px",
      border: "none",
      "& .MuiAutocomplete-input": {
        position: "relative",
        border: "solid 1px #979797",
        backgroundColor: "#fff",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        transition: theme.transitions.create([
          "border-color",
          "background-color",
          "box-shadow",
        ]),
      },
    },
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },

  "& .MuiInputBase-input": {
    border: "1px solid #7f7f7f",
    position: "relative",
    backgroundColor: "#fff",
    paddingTop: "7px",
    paddingBottom: "9px",
    paddingLeft: "10px",
    height: "24px",
    fontFamily: "Inter",
    fontSize: "16px",
    paddingRight: {
      xs: "30.3px",
      sm: "40.6px",
      md: "47.9px",
      lg: "51.1px",
    },
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000",
      color: "#000000",
    },
  },
}));

const BootstrapSelect = styled(Select)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },

  "& .MuiInputBase-input": {
    position: "relative",
    border: "solid 1px #979797",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000 !important",
      borderBottom: "#000 !important",
    },
    "&.MuiSelect-root:after": {
      borderBottom: "#000 !important",
    },
  },
}));

const LoginServiceAddress = () => {
  const captchaRef = useRef(null);
  const loginContent: any = LoginContent();
  const LOGIN_CONTENTS: any = loginContent?.entry;
  const LOGIN_USERNAME = LOGIN_CONTENTS?.login?.username;
  const { customNavigate } = useCustomNavigate();
  const serviceAddressSchema = yup
    .object({
      serviceAddress: yup.string().nullable(),
      phoneNumber: yup
        .string()
        .when("githubUsername", {
          is: (value: string) => value?.length,
          then: (rule) =>
            rule.matches(
              /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
              "Invalid phone number"
            ),
        })
        .max(14, "Invalid phone number")
        .nullable(),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { isDirty, errors },
    setValue,
    getValues,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(serviceAddressSchema),
    mode: "onChange",
    defaultValues: {
      serviceAddress: "",
      phoneNumber: "",
      selectedLoginOptions: "phoneNumber",
      //selectedLoginOptions: "serviceAddress",
    },
  });
  const navigate = useNavigate();
  /*const LOGIN_CONTENTS: any = useAppSelector(
    (state) => state?.contentDetails?.loginPageContent
  );
  const LOGIN_USERNAME = LOGIN_CONTENTS?.entry?.login?.username;*/

  const dispatch = useAppDispatch();
  const headers = useBrightspeedHeaders();
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const amsToken = useAppSelector((state) => state?.amsToken?.data);
  const [suggetionsAddresses, setSuggetionsAddress] = useState<any[]>([]);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [isSuggetionsLoading, setIsSuggectionLoading] = useState(false);
  const [isOptionSelected, setIsOpenSelected] = useState(false);
  const [openAddressSuggetionDropdown, setOpenAddressSuggetionDropdown] =
    useState(false);
  const [selectedEnties, setSelectedEnties] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies<any>(["uni-login"]);
  const [rememberMeBtnChecked, setRememberMeBtnChecked] = useState(false);
  const maskPhoneNumberRegex = /^[0-9\-()\[\]\s]*$/;
    const location = useLocation();
  const fullUrl= `${window.location.origin}${location.pathname}`
  useEffect(() => {
     if(fullUrl?.includes("https://myaccountnextqa2.brightspeed.com/uni-login")) {      
           return   customNavigate("/login");
          }
    if (!LOGIN_CONTENTS) {
      getContent();
    }
    dispatch(logout());
    dispatch(resetAllBanners());
    dispatch(clearNextPaymentDetailSlice());
    dispatch(clearPaymentHistorySlice());
    dispatch(clearPaymentMethodsSlice());
    dispatch(clearServiceDetailSlice());
    dispatch(clearUpcomingAppointmentSlice());
    dispatch(clearProductCategoriesSlice());
    dispatch(clearAccordionStateSlice());
    dispatch(clearinternetProductsSlice());
    dispatch(clearPastAppointmentSlice());
    dispatch(clearPlanDetailSlice());
    dispatch(setChangePlanUrl(""));
    dispatch(getAMSToken());
  }, []);

  useEffect(() => {
    if (cookies?.serviceAddress || cookies?.phoneNumber) {
      setRememberMeBtnChecked(true);
      setValue("selectedLoginOptions", cookies?.selectedLoginOptions || "");
      if (cookies?.selectedLoginOptions === "serviceAddress") {
        setValue("serviceAddress", cookies?.serviceAddress || "");
        setValue("phoneNumber", "");
      } else if (cookies?.selectedLoginOptions === "phoneNumber") {
        setValue("phoneNumber", cookies?.phoneNumber || "");
        setValue("serviceAddress", "");
      }
    }
  }, []);

 
  useEffect(() => {
    if (watch("selectedLoginOptions") === "serviceAddress") {
      setValue("serviceAddress", "");
      setValue("phoneNumber", "");
      setIsOpenSelected(false);
      clearErrors("serviceAddress");
      clearErrors("phoneNumber");


    } else if (watch("selectedLoginOptions") === "phoneNumber") {
      setValue("phoneNumber", "");
      setValue("serviceAddress", "");
      clearErrors("phoneNumber");
      clearErrors("serviceAddress");
    }
    if (
      watch("selectedLoginOptions") === "serviceAddress" &&
      !isDirty &&
      cookies?.serviceAddress
    ) {
      setIsOpenSelected(true);
    }
  }, [watch("selectedLoginOptions")]);

  // useEffect(() => {
  //   if (
  //     process.env.REACT_APP_ENV === "production" &&
  //     globalToken?.access_token
  //   ) {

  //   } else if (process.env.REACT_APP_ENV !== "production") {

  //   }
  // }, [globalToken]);

  const getContent = async () => {
    // await dispatch(getLoginPageContent());
  };

  const getAddressSuggetionsList = async (
    value: string,
    selectedValue: string
  ) => {
    try {
      if (value) {
        setIsSuggectionLoading(true);
        let query = `lookup?address=${value}`;
        if (selectedValue) {
          query = query + `&selected=${selectedValue}`;
        }
        const addressSuggetionsRes = await AMS_Lookup(
          {
            [AllUrls?.amsLookUpURL]: query,
          },
          {
            Authorization: `Bearer ${amsToken?.id}`,
          }
        );
        if (
          addressSuggetionsRes?.status === 200 &&
          addressSuggetionsRes?.data?.responseData?.addresses?.length
        ) {
          setSuggetionsAddress(
            addressSuggetionsRes?.data?.responseData?.addresses
          );
        }
        setIsSuggectionLoading(false);
      } else {
        setSuggetionsAddress([]);
      }
    } catch (error) {
      setIsSuggectionLoading(false);
      console.error(error);
    }
  };

  const onAddressChange = useCallback(debounce(getAddressSuggetionsList), [
    amsToken,
  ]);

  const onSubmit = async (data: any) => {
    if (data?.serviceAddress) {
      if (rememberMeBtnChecked) {
        setCookie("serviceAddress", data?.serviceAddress, { path: "/" });
        setCookie("selectedLoginOptions", data?.selectedLoginOptions, {
          path: "/",
        });
        removeCookie("phoneNumber", { path: "/" });
      } else {
        removeCookie("serviceAddress", { path: "/" });
        removeCookie("selectedLoginOptions", { path: "/" });
        removeCookie("phoneNumber", { path: "/" });
      }
      uniLogineventGTM("serviceAddress", data?.serviceAddress);
      //FS log
      sendEventLog("Uni-login - Address Check CTA Clicked", {});

      try {
        dispatch(startLoading());
        dwLogging(
          {
            "": AllUrls?.dwLoggingUrl,
          },
          {
            sessionId: localStorage?.getItem("sessionId") || "",
            stepName: EC_DW_LOGGING_STEPS?.uni_login_address_attempt,
            cta: LOGIN_USERNAME?.continue_button_label,
            req: data?.serviceAddress,
          },
          headers
        );
        const addressQualificationRes = await addressQualification(
          {
            "": `${AllUrls?.addressQualificationURL}?addressLine1=${data?.serviceAddress}&existingUser=EC`,
          },
          headers
        );
        dispatch(stopLoading());
        if (
          addressQualificationRes?.status === 200 &&
          addressQualificationRes?.data?.entity?.brightSpeedFiberIndicator
        ) {
          logServiceCheckResult(
            addressQualificationRes.data.entity.brightSpeedFiberIndicator
          );
          navigateByResponse(
            addressQualificationRes?.data?.entity?.brightSpeedFiberIndicator,
            addressQualificationRes?.data?.entity?.instantInternet,
            false,
            data?.serviceAddress,
            addressQualificationRes?.data?.entity?.existingService,
            addressQualificationRes?.data?.entity?.pendingOrder
          );
        }
      } catch (error) {
        //FS log
        sendEventLog("Uni-login - Address Failure", {});
        dispatch(stopLoading());
        console.error(error);
      }
    } else if (data?.phoneNumber) {
      if (rememberMeBtnChecked) {
        setCookie("phoneNumber", data?.phoneNumber, { path: "/" });
        setCookie("selectedLoginOptions", data?.selectedLoginOptions, {
          path: "/",
        });
        removeCookie("serviceAddress", { path: "/" });
      } else {
        removeCookie("phoneNumber", { path: "/" });
        removeCookie("selectedLoginOptions", { path: "/" });
        removeCookie("serviceAddress", { path: "/" });
      }
      uniLogineventGTM("phoneNumber", data?.phoneNumber);
      //FS log
      sendEventLog("Uni-login - Phone Number Check CTA Clicked", {});

      const phNumber = data.phoneNumber?.replace(/\D+/g, "");
      try {
        dispatch(startLoading());
        dwLogging(
          {
            "": AllUrls?.dwLoggingUrl,
          },
          {
            sessionId: localStorage?.getItem("sessionId") || "",
            stepName: EC_DW_LOGGING_STEPS?.uni_login_phoneNumber_attempt,
            cta: LOGIN_USERNAME?.continue_button_label,
            req: phNumber,
          },
          headers
        );
        const response = await unifiedLoginWithMobileNumber(
          {
            "": `${AllUrls.unifiedLoginWithMobileNumberTN_lookup_Url}?tn=${phNumber}`,
          },
          headers
        );
        dispatch(stopLoading());
        if (response?.status === 200 && response?.data) {
          logServiceCheckResult(response.data);
          navigateByResponse(
            response?.data,
            response?.data === "Quantum Fiber Qualified",
            true,
            phNumber,
            false,
            false
          );
        }
      } catch (error) {
        //FS log
        sendEventLog("Uni-login - Phone Number Failure", {});
        dispatch(stopLoading());
        navigateByResponse("", false, true, phNumber, false, false);
        console.error(error);
      }
    }
  };

  const navigateByResponse = (
    brightSpeedFiberIndicator: string,
    instantInternet: boolean,
    fromPhoneNumber: boolean,
    value: string,
    existingService: boolean,
    pendingOrder: boolean
  ) => {
    switch (brightSpeedFiberIndicator) {
      case "QUALIFIED":
        // account management
        addDwlogs("brspd", !!fromPhoneNumber, value);
        if (existingService || pendingOrder) {
          customNavigate("/login");
        } else {
          // Century Link
          addDwlogs("ctl", !!fromPhoneNumber, value);
          if (process.env.REACT_APP_CENTURY_LINK_UNI_LOGIN_PAGE)
            window.open(
              process.env.REACT_APP_CENTURY_LINK_UNI_LOGIN_PAGE,
              "_self"
            );
        }
        break;
      case "Brightspeed Fiber Qualified":
        //  mobile number (111) 111-1222
        addDwlogs("brspd", !!fromPhoneNumber, value);
        customNavigate("/login");
        break;
      case "Brightspeed Copper Qualified":
        addDwlogs("Copper Qualified", !!fromPhoneNumber, value);
        customNavigate("/login", { state: { Migrated_Ctl: true } });
        break;
      case "QF QUALIFIED":
        // QuantumFiber
        addDwlogs(instantInternet ? "qf-ii" : "qf", !!fromPhoneNumber, value);
        customNavigate("/login", { state: { QF_user: true } });
        break;
      case "Quantum Fiber Qualified":
        addDwlogs(instantInternet ? "qf-ii" : "qf", !!fromPhoneNumber, value);
        customNavigate("/login", { state: { QF_user: true } });
        break;
      case "COPPER QUALIFIED":
        addDwlogs("Copper Qualified", !!fromPhoneNumber, value);
        customNavigate("/login", { state: { Migrated_Ctl: true } });
        break;  
      case "CTL QUALIFIED":
        // Century Link
        addDwlogs("ctl", !!fromPhoneNumber, value);
        if (process.env.REACT_APP_CENTURY_LINK_UNI_LOGIN_PAGE)
          window.open(
            process.env.REACT_APP_CENTURY_LINK_UNI_LOGIN_PAGE,
            "_self"
          );
        break;
      case "CTL Qualified":
        // Century Link
        addDwlogs("ctl", !!fromPhoneNumber, value);
        if (process.env.REACT_APP_CENTURY_LINK_UNI_LOGIN_PAGE)
          window.open(
            process.env.REACT_APP_CENTURY_LINK_UNI_LOGIN_PAGE,
            "_self"
          );
        break;
      default:
        // error page
        addDwlogs("no-match", !!fromPhoneNumber, value);
        customNavigate("/uni-login-no-match", {
          state: { fromPhoneNumber },
        });
    }
  };

  const getServiceCheckResult = (indicator: string) => {
    switch (indicator) {
      case "QUALIFIED":
        return "Uni-login BRSPD Fiber address";
      case "QF QUALIFIED":
        return "Uni-login QF address";
      case "CTL QUALIFIED":
        return "Uni-login CTL address";
      case "Brightspeed Fiber Qualified":
        return "Uni-login BRSPD Fiber phone number";
      case "Quantum Fiber Qualified":
        return "Uni-login QF phone number";
      case "CTL Qualified":
        return "Uni-login CTL phone number";
      default:
        return "";
    }
  };

  const logServiceCheckResult = (indicator: string) => {
    if (indicator) {
      const result = getServiceCheckResult(indicator);
      sendEventLog(result, {});
    }
  };

  const onAddressFieldChange = (_: any, slectedAddress: any, reason: any) => {
    if (reason === "selectOption") {
      if (slectedAddress?.entries > 1) {
        setValue(
          "serviceAddress",
          `${slectedAddress?.street_line} ${slectedAddress?.secondary}`
        );
        setSelectedEnties(
          `${slectedAddress?.street_line} ${slectedAddress?.secondary} (${slectedAddress?.entries}) ${slectedAddress?.city} ${slectedAddress?.state} ${slectedAddress?.zipcode}`
        );
        setSuggetionsAddress([]);
        onAddressChange(
          `${slectedAddress?.street_line} ${slectedAddress?.secondary}`,
          `${slectedAddress?.street_line} ${slectedAddress?.secondary} (${slectedAddress?.entries}) ${slectedAddress?.city} ${slectedAddress?.state} ${slectedAddress?.zipcode}`
        );
        if (!openAddressSuggetionDropdown) {
          setOpenAddressSuggetionDropdown(true);
        }
      } else {
        setIsOpenSelected(true);
        if (openAddressSuggetionDropdown) {
          setOpenAddressSuggetionDropdown(false);
        }
        setSelectedEnties("");
        setValue(
          "serviceAddress",
          slectedAddress?.secondary
            ? `${slectedAddress?.street_line} ${slectedAddress?.secondary} ${slectedAddress?.city}, ${slectedAddress?.state}, ${slectedAddress?.zipcode}`
            : `${slectedAddress?.street_line} ${slectedAddress?.city}, ${slectedAddress?.state}, ${slectedAddress?.zipcode}`
        );
      }
    }
  };

  const onAddressFieldInputChange = (_: any, value: string, reason: string) => {
    if (showErrorMsg && suggetionsAddresses?.length > 0) {
      clearErrors("serviceAddress");
      setShowErrorMsg(false);
    }
    if (!openAddressSuggetionDropdown) {
      setOpenAddressSuggetionDropdown(true);
    }
    if (reason === "input") {
      setValue(
        "serviceAddress",
        value?.replace(/[\&\\#,+()$~%.'":;*?<>{}]/gi, "")
      );
      setIsOpenSelected(false);
      onAddressChange(value, selectedEnties);
      if (!selectedEnties?.includes(value)) {
        setSelectedEnties("");
      }
    }
  };

  const getAddressOptionLabel = (option: any) => {
    return option?.entries > 1
      ? `${option?.street_line} ${option?.secondary} (${option?.entries}) ${option?.city} ${option?.state} ${option?.zipcode}`
      : option?.secondary
      ? `${option?.street_line} ${option?.secondary} ${option?.city} ${option?.state} ${option?.zipcode}`
      : `${option?.street_line} ${option?.city} ${option?.state} ${option?.zipcode}`;
  };

  const addressRenderOptions = (props: any, option: any) => {
    return (
      <li
        key={
          option?.street_line +
          option?.secondary +
          option?.city +
          option?.state +
          option?.zipcode +
          option?.source
        }
        {...props}
        className="serviceAddressList fs-mask"
      >
        {option?.entries > 1
          ? `${option?.street_line} ${option?.secondary} (${option?.entries}) ${option?.city} ${option?.state} ${option?.zipcode}`
          : option?.secondary
          ? `${option?.street_line} ${option?.secondary} ${option?.city} ${option?.state} ${option?.zipcode}`
          : `${option?.street_line} ${option?.city} ${option?.state} ${option?.zipcode}`}
      </li>
    );
  };

  const addDwlogs = (
    step: string,
    isItFromPhoneNumber: boolean,
    value: string
  ) => {
    dwLogging(
      {
        "": AllUrls?.dwLoggingUrl,
      },
      {
        sessionId: localStorage?.getItem("sessionId") || "",
        stepName: isItFromPhoneNumber
          ? EC_DW_LOGGING_STEPS?.uni_login_phoneNumber_success
          : EC_DW_LOGGING_STEPS?.uni_login_address_success,
        cta: LOGIN_USERNAME?.continue_button_label,
        customerType: step,
        // "ctl/brspd/qf/qf-ii",
        req: value,
      },
      headers
    );
  };

   const validateInput = async (value: string) => {
      const phNumber = value?.replace(/[^\d]/g, "");
       
      if(phNumber?.length<10 || phNumber?.length > 10){
        setError("phoneNumber", {
          type: "matches",
          message: "Please enter a valid phone number."
        });
        return false;
      }else{
        clearErrors("phoneNumber");
        return true
      }
    }

  return (
    <WithLoginLayout>
      <Stack className="loginMain">
        <Typography component="h1" className="title">
          {LOGIN_USERNAME?.title}
        </Typography>
        <Typography className="desc">
          {
            "Please enter your service address or phone number so we can bring you to your login page. Want more help? Chat with us below."
          }
        </Typography>

        <FormControl
          className="loginOptions"
          variant="standard"
          sx={{ width: "100%", my: 1 }}
        >
          <Typography component="label" htmlFor="selectedLoginOptions" id="selectPhone" className="font-secondary text-color-primary mb-1">
            Please select a login method</Typography>
          <BootstrapSelect
           className="mt-0"
            labelId="selectedLoginOptions"
            id="selectedLoginOptions"
            {...register("selectedLoginOptions")}
            aria-describedby="selectPhone"
            label="Service Address"
            defaultValue={cookies?.selectedLoginOptions || "phoneNumber"}
            sx={{ borderBottom: "#000 !important" }}
          >
            <MenuItem value="serviceAddress">Service Address</MenuItem>
            <MenuItem value="phoneNumber">Phone Number</MenuItem>
          </BootstrapSelect>
        </FormControl>
        {watch("selectedLoginOptions") === "serviceAddress" && (
          <FormControl variant="standard" className="form serviceAddressForm">
            <InputLabel
              shrink
              htmlFor="serviceAddress"
              className="serviceAddress"
            >
              {"Your service address*"}
            </InputLabel>          
            <BootstrapAutocomplete
              freeSolo
              id="serviceAddress"
              aria-describedby="serviceaddress-error"            
              inputValue={watch("serviceAddress")}
              disableClearable
              className={`autoCompleteMain ${
                Object.keys(errors).length !== 0 && showErrorMsg
                  ? "showErrorBorder"
                  : ""
              }`}
              open={openAddressSuggetionDropdown}
              onKeyDown={(event) => {
                if (event.key === 'Escape' || event.key === 'Tab') {
                  setOpenAddressSuggetionDropdown(false)
                }
              }}
              onChange={onAddressFieldChange}
              onInputChange={onAddressFieldInputChange}            
              onBlur={(e) => {
                Object.keys(errors).length !== 0
                  ? setShowErrorMsg(true)
                  : setShowErrorMsg(false);
                if (
                  !isSuggetionsLoading &&
                  suggetionsAddresses?.length === 0 &&
                  !showErrorMsg
                ) {
                  setShowErrorMsg(true);
                  setError("serviceAddress", {
                    type: "custom",
                    message: "Please enter a valid address",
                  });
                }
              }}
              options={suggetionsAddresses}
              loading={isSuggetionsLoading}
              getOptionLabel={getAddressOptionLabel}
              renderOption={addressRenderOptions}
              renderInput={(params) => (
                <TextField               
                  {...params}
                  // inputProps={{
                  //   ...params.inputProps,
                  // }}
                  inputProps={{
                    "aria-invalid":
                      errors && Object.keys(errors)?.includes("serviceAddress") ? "true" : "false",
                    ...params.inputProps,

                  }}
                  className="uni-login-address-input-placeholder fs-mask"
                  placeholder={
                    !watch("serviceAddress")
                      ? "Enter the address for your account"
                      : ""
                  }
                />
              )}
            />

            {showErrorMsg && (
              <ErrorMessage
                errors={errors}
                name="serviceAddress"
                render={({ message }) => (
                  <>
                    <span className="inputFiledErrorMsg"  
                    id="serviceaddress-error">{message}</span>
                  </>
                )}
              />
            )}
          </FormControl>
        )}
        {watch("selectedLoginOptions") === "phoneNumber" && (
          <FormControl variant="standard" className="form phoneNumberForm">
            <InputLabel shrink htmlFor="phoneNumber" className="email">
              {"Your phone number*"}
            </InputLabel>
            <BootstrapInput
              id="uni-login-phoneNumber"
              aria-describedby="phone-error"
              {...register("phoneNumber")}
              placeholder={"Enter the number for your account"}
              className={
                Object.keys(errors).length !== 0 && showErrorMsg
                  ? "showErrorBorder fs-mask"
                  : "fs-mask"
              }
              onKeyPress={(e: any) => {
               return phoneNumberValidationMask(e)
              }}
              onKeyDown={(e:any)=>{
                if(e.target.value.length < 11)
                e.target.value = e?.target?.value?.replace(
                  /^(\d{3})(\d{3})(\d{4})$/,
                  "($1) $2-$3"
                ).substr(0,14);
              }}
              onBlur={async (e) => {
                if(e?.target?.value){
                  const isValid = await validateInput(e?.target?.value); // Await the validation result
                  if (isValid) {
                    clearErrors("phoneNumber");
                  }
                }else if (e?.target?.value===""){
                  clearErrors("phoneNumber");
                }
                  Object.keys(errors).length !== 0
                    ? setShowErrorMsg(true)
                    : setShowErrorMsg(false);
                 
              }}      
              inputProps={{
                "aria-invalid":
                  errors && Object.keys(errors)?.includes("phoneNumber") ? "true" : "false",
                 "aria-required": true,
                 maxLength:14
              }}
            />

            {showErrorMsg && (
              <ErrorMessage
                errors={errors}
                name="phoneNumber"
                render={({ message }) => (
                  <>
                    <span className="inputFiledErrorMsg" id="phone-error" >{message}</span>
                  </>
                )}
              />
            )}
          </FormControl>
        )}
        {/* <Box className="login_reCaptcha">
          <RECAPTCHA
            sitekey={"6Lf1HOMjAAAAAChywPLQbSymObq1eWXwj69pBGpb"}
            ref={captchaRef}
          />
        </Box> */}
        <Box className="rememberMe">
          <Typography component="span" className="checkBox">
            <label className="checkboxMain">
              {LOGIN_USERNAME?.remember_label}
              <input
                type="checkbox"
                checked={rememberMeBtnChecked}
                aria-checked={rememberMeBtnChecked}
                onClick={(e: any) =>
                  setRememberMeBtnChecked(e?.target?.checked)
                }
                className="radioInput"
              />
              <span className="checkBoxLabel"></span>
            </label>
            {
              // <Checkbox /> {LOGIN_USERNAME?.remember_label}
            }
          </Typography>
        </Box>
        <Button
          disabled={
            watch("selectedLoginOptions") === "serviceAddress"
              ? !isOptionSelected
              : (Object.keys(errors)?.length !== 0 || !getValues('phoneNumber'))
          }
          className="homeButton btnEnabled"
          onClick={handleSubmit(onSubmit)}
        >
          {LOGIN_USERNAME?.continue_button_label}
        </Button>
        <Divider className="logindivider" role="presentation"/>
        <LoginRegFooter />
      </Stack>
    </WithLoginLayout>
  );
};
export default LoginServiceAddress;
